import type { ReactElement } from 'react';

import { AnimateIcon } from '@dvb/ui';
import { cloneElement } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

interface Props {
  actionElement?: ReactElement;
  className?: string;
  description?: string;
  icon?: 'error' | 'warning';
  title?: string;
  traceId?: string;
}

export function BaseErrorLayout({
  actionElement = undefined,
  className = undefined,
  description = undefined,
  icon = 'error',
  title = undefined,
  traceId = undefined,
}: Props) {
  const { t } = useTranslation('ui');
  return (
    <main
      className={twMerge(
        'bg-default-50 min-h-screen p-4 duration-300',
        className
      )}
    >
      <div className="absolute left-1/2 top-1/2 flex w-10/12 -translate-x-1/2 -translate-y-1/2 flex-col justify-center">
        <AnimateIcon className="mx-auto mb-2" type={icon} />
        <h1 className="mx-auto mb-2 text-center text-xl font-bold">
          {title || t('somethingWrong')}
        </h1>
        <span className="text-center">{description}</span>
        {actionElement &&
          cloneElement(actionElement, {
            className: 'mx-auto mt-4 w-1/2',
          })}
        {traceId && (
          <div className="text-default-500 mt-6 flex flex-col overflow-hidden text-center">
            <p>{t('traceId')}</p>
            <p>{traceId}</p>
          </div>
        )}
      </div>
    </main>
  );
}
